class Data {
    static MOCK_TIMELINES = [
        {
            TimelineName: "EP-DASHBOARD",
            Schedules: [
                { WeekDays: "1,2,3,4,5", StartDate: "01-10-2020", EndDate: "05-10-2020", StartTime: "11:00", EndTime: "22:00" },
                { WeekDays: "0,6", StartDate: "01-10-2020", EndDate: "05-10-2020", StartTime: "10:00", EndTime: "21:00" },
            ],
            Layout: {
                width: 1080,
                height: 1920,
                slots: {

                }
            }
        }

    ]
    static MOCK_BRANCHES = [
        {
            BranchID: 8,
            BrandID: 1,
            BranchCode: "cdx",
            BranchName: "cdx",
            BranchlStatus: 4
        },
        {
            BranchID: 14,
            BrandID: 1,
            BranchCode: "DEMO",
            BranchName: "DEMO",
            BranchlStatus: 1
        },
        {
            BranchID: 24,
            BrandID: 1,
            BranchCode: "Demo01",
            BranchName: "Demo Main Street",
            BranchlStatus: 4
        },
        {
            BranchID: 15,
            BrandID: 4,
            BranchCode: "DEMO",
            BranchName: "DEMO",
            BranchlStatus: 4
        },
        {
            BranchID: 16,
            BrandID: 5,
            BranchCode: "JTestBr",
            BranchName: "JTestBr",
            BranchlStatus: 4
        },
        {
            BranchID: 25,
            BrandID: 8,
            BranchCode: "ziHDi",
            BranchName: "New branch",
            BranchlStatus: 1
        }
    ]
    static MOCK_BRANDS = [
        {
            BrandID: 1,
            BrandName: "DEMO",
            BrandCode: "DMO",
            ContactPerson: "",
            ContactStaff: "",
            AddDate: "2020-04-16 00:00:00",
            StartDate: "",
            EndDate: "",
            SVGLogo: "1587394744_80699.svg",
            ThemeColor: "#49C8F4",
            BrandStatus: "Open"
        },
        {
            BrandID: 4,
            BrandName: "TEST12",
            BrandCode: "TEST",
            ContactPerson: "wwww",
            ContactStaff: "www",
            AddDate: "2020-05-13 00:00:00",
            StartDate: "2020-04-29 00:00:00",
            EndDate: "2020-05-05 00:00:00",
            SVGLogo: "",
            ThemeColor: "",
            BrandStatus: "Open"
        },
        {
            BrandID: 5,
            BrandName: "JTest",
            BrandCode: "JTest",
            ContactPerson: "",
            ContactStaff: "",
            AddDate: "",
            StartDate: "",
            EndDate: "",
            SVGLogo: "",
            ThemeColor: "",
            BrandStatus: "Open"
        },
        {
            BrandID: 7,
            BrandName: "AAA",
            BrandCode: "fqqbV",
            ContactPerson: "",
            ContactStaff: "",
            AddDate: "2020-09-15 13:49:38",
            StartDate: "",
            EndDate: "",
            SVGLogo: "",
            ThemeColor: "",
            BrandStatus: "Open"
        },
        {
            BrandID: 8,
            BrandName: "BBB",
            BrandCode: "lRqbq",
            ContactPerson: "",
            ContactStaff: "",
            AddDate: "2020-09-15 13:53:57",
            StartDate: "",
            EndDate: "",
            SVGLogo: "",
            ThemeColor: "",
            BrandStatus: "Open"
        },
        {
            BrandID: 9,
            BrandName: "CCC",
            BrandCode: "aHjEY",
            ContactPerson: "",
            ContactStaff: "",
            AddDate: "2020-09-15 13:54:50",
            StartDate: "",
            EndDate: "",
            SVGLogo: "",
            ThemeColor: "",
            BrandStatus: "Open"
        }
    ]

    static MOCK_CAMPAIGNS = [
        {
            CampaignID: 1,
            CampaignName: "Nike Ads Fes Intro 2020",
            StartDate: "2020-09-15",
            EndDate: "2020-09-15",
            StartTime: "13:54:50",
            EndTime: "13:54:50",
        },
        {
            CampaignID: 2,
            CampaignName: "Nike Ads Fes Intro 2020",
            StartDate: "2020-09-15",
            EndDate: "2020-09-15",
            StartTime: "13:54:50",
            EndTime: "13:54:50",
        },
        {
            CampaignID: 3,
            CampaignName: "Nike Ads Fes Intro 2020",
            StartDate: "2020-09-15",
            EndDate: "2020-09-15",
            StartTime: "13:54:50",
            EndTime: "13:54:50",
        },
        {
            CampaignID: 4,
            CampaignName: "Nike Ads Fes Intro 2020",
            StartDate: "2020-09-15",
            EndDate: "2020-09-15",
            StartTime: "13:54:50",
            EndTime: "13:54:50",
        }
    ]

    static MOCK_CAMPAIGN_CONTENTS = [
        {
            CampaignContentID: 1,
            ContentName: "Content1",
            Duration: "00:15:00"
        },
        {
            CampaignContentID: 2,
            ContentName: "Content2",
            Duration: "00:18:00"
        },
        {
            CampaignContentID: 3,
            ContentName: "Content3",
            Duration: "00:20:00"
        }
    ]
    static MOCK_SCREEN_CONTENTS = [
        {
            ScreenID: 1,
            ScreenName: "Screen1",
            Campaign: "Campaign1",
            status: "Online"
        },
        {
            ScreenID: 2,
            ScreenName: "Screen2",
            Campaign: "Campaign1",
            status: "Online"
        },
        {
            ScreenID: 3,
            ScreenName: "Screen3",
            Campaign: "Campaign1",
            status: "Online"
        },
    ]
}

export const mockFileFolderData = [
    {
        id: 1,
        type: "folder",
        name: "folder1",
        parentID: 0
    },
    {
        id: 2,
        type: "folder",
        name: "folder2",
        parentID: 0
    },
    {
        id: 3,
        type: "folder",
        name: "folder3",
        parentID: 1
    },
    {
        id: 4,
        type: "file",
        name: "file1.txt",
        parentID: 2,
        itemID: 1
    },
    {
        id: 5,
        type: "file",
        name: "file2.jpg",
        parentID: 3,
        itemID: 2
    },
    {
        id: 6,
        type: "file",
        name: "file3.txt",
        parentID: 2,
        itemID: 3
    },
    {
        id: 7,
        type: "file",
        name: "file4.jpg",
        parentID: 1,
        itemID: 4
    }
]

export default Data